//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PortfolioCard from "~/components/portfolios/PortfolioCard";
import GetAllProjects from "~/apollo/queries/Project/getAllProjects";
import Categories from "~/apollo/queries/getCategories";

export default {
  components: {
    PortfolioCard,
  },
  data() {
    return {
      filteredPorts: [],
    };
  },
  computed: {
    filtPortfolio() {
      if (this.filteredPorts.length > 0) {
        return this.filteredPorts;
      } else {
        return this.portfolios;
      }
    },
  },
  apollo: {
    portfolios: {
      query: GetAllProjects,
      update(data) {
        return data.portfolios?.edges;
      },
    },
    categories: {
      query: Categories,
      update(data) {
        return data.categories?.edges;
      },
    },
  },
  methods: {
    getLink(id) {
      this.linkString = "/work/" + id;
      return this.linkString;
    },
    filter(categoryName) {
      this.filteredPorts = this.portfolios.filter((Obj) =>
        Obj.node.categories.nodes.some((c) => c.name === categoryName)
      );
    },
    clearFilter() {
      this.filteredPorts = [];
    }
  },
};
